import { Directive, ElementRef, HostListener, NgZone, Renderer2 } from '@angular/core';

@Directive({
  selector: '[sharryFormScroll]',
  standalone: true,
})
export class FormScrollDirective {
  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private ngZone: NgZone,
  ) {}

  @HostListener('focus', ['$event']) onFocus() {
    this.renderer.setStyle(
      this.el.nativeElement,
      'scroll-margin-top',
      'calc(64px + env(safe-area-inset-top) + 1.5rem)',
    );
    this.renderer.setStyle(
      this.el.nativeElement,
      'scroll-snap-margin-top',
      'calc(64px + env(safe-area-inset-top) + 1.5rem)',
    );
    if (this.el.nativeElement.hasAttribute('matInput')) {
      this.renderer.setStyle(
        this.el.nativeElement,
        'scroll-padding-top',
        'calc(64px + env(safe-area-inset-top) + 3rem)',
      );
      this.renderer.setStyle(
        this.el.nativeElement,
        'scroll-snap-padding-top',
        'calc(64px + env(safe-area-inset-top) + 3rem)',
      );
    }
    this.ngZone.runOutsideAngular(() =>
      setTimeout(() => {
        this.el.nativeElement.scrollIntoView({ block: 'start', inline: 'start', behavior: 'smooth' });
      }, 100),
    );
  }
}
